import React from 'react';
import { formatConfidencePercent } from '../lib/networkIntelligenceFormatters';

const badgeClass = (confidence) => {
  const value = Number(confidence || 0);
  if (value >= 0.8) return 'border-red-500/60 bg-red-500/20 text-red-200';
  if (value >= 0.6) return 'border-amber-500/60 bg-amber-500/20 text-amber-200';
  if (value >= 0.4) return 'border-blue-500/60 bg-blue-500/20 text-blue-200';
  return 'border-slate-600 bg-slate-800 text-slate-200';
};

const RiskConfidenceBadge = ({ confidence }) => {
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-1 text-xs font-semibold ${badgeClass(confidence)}`}>
      Confidence {formatConfidencePercent(confidence)}
    </span>
  );
};

export default RiskConfidenceBadge;
